// en.js
export const locale = {
  // default resource
  vue_form_generator_resources: {
    fieldIsRequired: "This field is required!",
    invalidFormat: "Invalid format!",

    numberTooSmall: "The number is too small! Minimum: {0}",
    numberTooBig: "The number is too big! Maximum: {0}",
    invalidNumber: "Invalid number",
    invalidInteger: "The value is not an integer",

    textTooSmall: "The length of text is too small! Current: {0}, Minimum: {1}",
    textTooBig: "The length of text is too big! Current: {0}, Maximum: {1}",
    thisNotText: "This is not a text!",

    thisNotArray: "This is not an array!",

    selectMinItems: "Select minimum {0} items!",
    selectMaxItems: "Select maximum {0} items!",

    invalidDate: "Invalid date!",
    dateIsEarly: "The date is too early! Current: {0}, Minimum: {1}",
    dateIsLate: "The date is too late! Current: {0}, Maximum: {1}",

    invalidEmail: "Invalid e-mail address!",
    invalidURL: "Invalid URL!",

    invalidCard: "Invalid card format!",
    invalidCardNumber: "Invalid card number!",

    invalidTextContainNumber: "Invalid text! Cannot contains numbers or special characters",
    invalidTextContainSpec: "Invalid text! Cannot contains special characters"
  },
  // local resource
  form_title: {
    normal: 'Activate your account',
    complete: 'Activate your account'
  },
  footer_title: {
    normal: ['Already have an account?', 'Login'],
    complete: ['Already have an account?', 'Login']
  },
  form: {
    license_group: {
      label: 'Activation information',
    },
    license_id: {
      label: 'Activation code',
      placeholder: '',
      hint: ' 12345678-9abcdef1-23456789-abcdef12',
    },
    license_product: {
      label: 'Product name',
      placeholder: '',
      hint: '',
    },
    license_plan: {
      label: 'Product plan',
      placeholder: '',
      hint: '',
    },
    license_term: {
      label: 'Product duration',
      placeholder: '',
      hint: '',
    },
    login_group: {
      label: 'Login information',
    },
    login_account: {
      label: 'Account',
      placeholder: '',
      hint: '6~25 alphanumeric and underline',
    },
    login_password: {
      label: 'Password',
      placeholder: '',
      hint: '8-20 characters, must contain at least one uppercase letter, one lowercase letter, one number, and one visible special character (~!@#$^*0_+)',
    },
    login_confirm_password: {
      label:'Confirm passwod',
      placeholder:'',
      hint: '',
    },
    display_group: {
      label: 'Display information',
    },
    display_company: {
      label:'Company name',
      placeholder:'',
      hint: ' 日本コンピュータビジョン株式会社',
    },
    display_username: {
      label:'User name',
      placeholder:'',
      hint: '',
    },
    display_phone: {
      label:'Phone number',
      placeholder:'',
      hint: ' 080-1234-5678',
    },
    display_email: {
      label:'Email address',
      placeholder:'',
      hint: ' user@japancv.co.jp',
    }
  },
  validate_form: {
    otp_code: {
      label: 'OTP',
      placeholder: '',
      hint: '',
      button_labels: [''],
    }
  },
  field: {
    warning: {
      mismatch_password: "Passwords don't match.",
    }
  },
  button: {
    title: {
      validation: 'Validation',
      confirm: 'Confirm',
      submit: 'Submit',
      apply: 'Apply',
      cancel: 'Cancel',
      otp_request: 'Request OTP',
      otp_resend: 'Resend OTP(%s)',
    }
  },
  modal: {
    title: {
      validation: 'Email Validation',
    }
  },
  toast: {
    title: {
      warning: 'Warning',
      confirm: 'Confirm',
      submit: 'Submit',
      cancel: 'Cancel',
    },
    msg: {
      invalid_code: 'The activation code is invalid.',
      valid_code: 'The activation code is valid',
      inavailable_account: 'The account is not available.',
      available_account: 'The account is available',
      invalid_phone: 'The phone number is invalid',
      valid_phone: 'The phone number is valid',
      invalid_otp: 'The OTP is invalid',
      valid_otp: 'The OTP is valid',
      confirm: 'Please check the form again.',
      success: 'The form is uploaded.',
      failure: 'There is a problem with the network. Please try again later.'
    }
  }
}
